import { t } from '@if/core/i18n'
import * as yup from '@if/core/yup'
import { useMemo } from 'react'
import { FinancingConfigDto } from './../../node_modules/@applyonline/shared/types/FinancingConfigApi'

function buildWorksheetSchema(
  availableCredit: number,
  amountRequested: number,
  term: number,
  financingProrgamConfig: FinancingConfigDto,
) {
  return yup.object({
    amountRequested: yup
      .double()
      .required()
      .default(amountRequested)
      .min(financingProrgamConfig.minimumLoanAmount, () =>
        t('worksheet.error.between', { min: financingProrgamConfig.minimumLoanAmount, max: availableCredit }),
      )
      .max(availableCredit, () =>
        t('worksheet.error.between', { min: financingProrgamConfig.minimumLoanAmount, max: availableCredit }),
      ),
    term: yup.integer().required().default(term),
    firstPaymentOn: yup.string().dateOnly().validDate().required(),
    includeInsurance: yup.boolean().required(),
  })
}
export function useWorksheetSchema(
  availableCredit: number,
  amountRequested: number,
  term: number,
  financingProrgamConfig: FinancingConfigDto,
) {
  return useMemo(
    () => buildWorksheetSchema(availableCredit, amountRequested, term, financingProrgamConfig),
    [availableCredit, amountRequested, term, financingProrgamConfig],
  )
}

export type WorksheetForm = yup.InferType<ReturnType<typeof buildWorksheetSchema>>
